import { RootState } from 'handlers';

export const getPayoffPayments = (state: RootState) => state.payoffPayments;
